import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-company-news',
  templateUrl: './modify-company-news.component.html',
  styleUrls: ['./modify-company-news.component.css']
})
export class ModifyCompanyNewsComponent implements OnInit {

  editForm: any | FormGroup
  paramData:any = []
  companyNews: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleCustomerInfo: any= []
  companyNewsId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  companyid: any = "";
  cid:any
  file: any;
  url1: any = "";
  imageSingle: any = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllCompanyNews()
    this.editForm = this.fb.group({
      subject: [''],
      description: [''],
      image: ['']
    })
  }


  updateCompanyNews(){
    let body = {
      "id":this.companyid,
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "subject": String(this.editForm.get('subject').value),
      "image": this.url1,
      "video": "",
      "cid": this.cid
    }
    

    console.log(body)
    this.generic_service.updateCompanyNews(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllCompanyNews()
        this.cancelModel()
        this.toastr.success("Successfully Updated")
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
  onTableDataChange(event: any) {
    this.page = event;
    this.getAllCompanyNews();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllCompanyNews();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllCompanyNews(){
    this.generic_service.getAllCompanyNews().subscribe(
      (res:any)=> {
        console.log(res)
        this.companyNews = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }



  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }
  
  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.url1 = event.response
  
    });
  }

  viewImage(image:string){
    // this.videoSingle = ""
    // this.vv = ""

    this.imageSingle = image
  }

  getCompanyNewsById(id:any){
    this.companyid = id
    this.generic_service.getCompanyNewsById(id).subscribe(
      (response:any)=>{
        console.log(response)
        // this.singleCustomerInfo = []
        // this.singleCustomerInfo.push(response.response)
        this.editForm.patchValue({
          subject: response.response.subject,
          description: response.response.description,
          image: response.response.image,
        })
        console.log(this.editForm.value)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }
}
